'use client';

import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { useUserState } from '@entities/user';

import routes from '@shared/routes';
import { Flex, Spinner } from '@shared/ui-kit';

const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const { status } = useUserState();

  useEffect(() => {
    if (status === 'unauthenticated') {
      router.replace(routes.signin);
    }
  }, [router, status]);

  // общий loader
  if (status === 'initializing') {
    return (
      <Flex
        h="100vh"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size="xl" />
      </Flex>
    );
  }

  // экран ошибки проверки сессии
  if (status === 'error') {
    throw new Error();
  }

  if (status !== 'authenticated') {
    return null;
  }

  return children;
};

export default AuthGuard;
